// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPatient {
    static getAttributeTypeMap() {
        return MedicalBiPatient.attributeTypeMap;
    }
}
MedicalBiPatient.discriminator = undefined;
MedicalBiPatient.additionalProperties = false;
MedicalBiPatient.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "MedicalBiGender"
    },
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalBiAddress"
    },
];
//# sourceMappingURL=medicalBiPatient.js.map